import React from "react";

import { Navigate, useLocation } from "react-router-dom";
import { getCurrentAuth } from "../../hooks/useAxiosPrivate";
import MainContainer from "../Component/MainContainer";
import PageRoutes from "../../utils/constants";

function PrivateRoutes({
  children,
}: {
  children: React.ReactElement;
}): React.ReactElement {
  const auth = getCurrentAuth();
  let location = useLocation();

  if (!auth?.AccessToken) {
    return (
      <Navigate
        to={PageRoutes.Login}
        state={{ from: location.pathname, search: location.search }}
        replace
      />
    );
  }

  return (
    <MainContainer>
      <>{children} </>
    </MainContainer>
  );
}

export default PrivateRoutes;
